import { useCallback } from "react";
import { Button, EmptyState, Flex, Link, toast } from "@jsq/ds/core";
import { useAppContext } from "~/contexts/appContext";
import * as styles from "../styles_vanilla.css";

export type PublishSuccessStepProps = {
  templateName: string;
  arenaName: string;
  arenaId: number | null;
  isSystemTemplate: boolean;
};

export const PublishSuccessStep = ({
  templateName,
  arenaName,
  arenaId,
  isSystemTemplate,
}: PublishSuccessStepProps) => {
  const { user } = useAppContext();

  const handleGoToArena = useCallback(() => {
    if (!user.id || !arenaId) {
      toast.error("There was an error navigating to the arena");
      return;
    }
    const url = `/session_exchange/initiate/${user.id}?arena_id=${arenaId}&sess_ex_type=ADMIN_TO_STAFF&redirect_url=/dashboard`;
    window.open(url, "_blank", "noopener,noreferrer");
  }, [user.id, arenaId]);

  const title = isSystemTemplate ? "Template saved" : "Template published";

  const description = isSystemTemplate
    ? `${templateName} is now available in your system templates`
    : `${templateName} has been published onto ${arenaName}`;

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flex={1}
      className={styles.publishSuccessContent}
    >
      <EmptyState illustration="document-success" title={title} description={description}>
        {isSystemTemplate ? (
          <Link to="/reporting/settings" displayAsButton variant="primary" icon="arrow-left">
            Back to system templates
          </Link>
        ) : (
          arenaId && (
            <Button
              variant="primary"
              icon="arrow-up-right-from-square"
              iconPosition="right"
              onClick={handleGoToArena}
            >
              {`Go to ${arenaName}`}
            </Button>
          )
        )}
      </EmptyState>
    </Flex>
  );
};
